import { Breadcrumbs, Container, Link, Stack, Typography } from "@mui/material";
import MenuMenu from "./MenuMenu";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import icon_bikkuri from "../images/bikkuri.svg";
import { useEffect, useRef, useState } from "react";
import parse from 'html-react-parser';
import axios from "axios";
import { API } from "./constantsFront";

const D007RoadMap = () => {
  const [roadDetail, setRoadDetail] = useState("");
  let body = { authKey: API.API_KEY };
  const preview = localStorage.getItem("roadpreview");
  let previewdata = JSON.parse(preview);
  localStorage.removeItem("roadpreview");

  const refIsFirst = useRef(true);
  useEffect(() => {
    //初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (!previewdata) {
      //DBの内容を表示
      axios.post("/m_road_map/select/publish", body).then(res => {
        let road = res.data.road
        setRoadDetail(parse(road[0].content))
      })
    } else {
      //プレビュー表示
      setRoadDetail(parse(previewdata.content))
    }

    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  })

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      輸出要件・規制一覧
                    </Typography>
                  </Breadcrumbs>

                  <h1>輸出要件・規制一覧</h1>

                  { roadDetail }

                  {/* <div>本サイトで取り扱う輸出規制の一覧です。</div>

                  <p class="table-title">植物検疫</p>
                  <div>
                    植物（果物、野菜など）を貨物及び郵便物として輸出、又は携帯品として持ち出す場合に、輸出先国から求められている検疫条件を掲載しています。本サイトでは32品目、33国・地域の情報を掲載しています。<Link href="https://www.maff.go.jp/pps/j/search/detail.html" target="_blank">植物防疫所の輸出条件早見表</Link>についてもご参照ください。<br />
                  </div>
                  <div>
                    なお、本サイト上で植物検疫の輸出規制を確認する際は、以下の点にご注意ください。<br />
                    １．本サイト上で「輸出可」と検索結果で表示されたとしても、ワシントン条約等の各国・地域の植物検疫以外の条約・法令により輸出入が制限される場合があります。<br />
                    ２．国・地域によっては、植物の輸入に際して事前に農業担当当局または植物検疫当局の輸入許可がなければ、輸入が認められない場合があります。<br />
                    ３．輸出相手国の輸入許可に関する照会・手続については、現地荷受人等の関係者を通じて輸入国の農業担当当局または植物検疫当局に確認するか、あるいは対象国の在日大使館にお問い合わせください。
                  </div>

                  <p class="table-title">動物検疫</p>
                  <div>
                    加熱していない牛肉、豚肉、鶏肉、鶏卵を中心に、家畜衛生及び食品衛生の観点での輸出の可否、輸出先国・地域から求められている条件・手続等を掲載しています。<br />
                    畜産物を含む加工食品は、動物検疫の対象となることがあります。具体的な要件や輸出の可否は、輸出先国の検疫当局にご確認ください。
                  </div>

                  <p class="table-title">放射性物質</p>
                  <div>
                    原発事故に伴い諸外国・地域が講じている、日本産食品等（※）に対する規制措置の情報を掲載しています。<br />
                    ※酒類については、<Link href="https://www.nta.go.jp/taxes/shiraberu/saigai/higashinihon/sake/index.htm" target="_blank">国税庁WEBサイト</Link>をご確認ください。
                  </div>

                  <p class="table-title">残留農薬規制</p>
                  <div>
                    15品目×20ゕ国・地域及び国際基準の農薬の最大残留基準値を掲載しています。調査対象農薬成分は、日本において残留農薬基準値の設定がある農薬成分を検索できます。また、調査国・地域等の残留農薬基準値の設定状況と日本の残留農薬基準値とを比較できるようにしています。
                  </div>

                  <p class="table-title">食品添加物規制</p>
                  <div>
                    EUで登録されている食品添加物とその使用基準等を検索できます。
                  </div>

                  <p class="table-title">その他</p>
                  <div>
                    本サイトでは上記要件・規制を取り扱っていますが、その他にも、容器・包装、ラベル表示、動物用医薬品、重金属などの規則、製造・加工施設の認定、自由販売証明書、漁獲証明書等、国・地域や品目ごとに異なる要件や手続きがあるため、ご注意ください。
                  </div>

                  <div style={{
                    backgroundColor: "#FBECEB"
                    , padding: "20px 30px 20px 30px"
                    , marginTop: "20px"
                  }}>
                    <div style={{ color: "red", fontSize: "11", display: "flex" }}>
                      <img src={icon_bikkuri} style={{ width: "20px" }} />
                      <div style={{ fontWeight: "700", marginLeft: "10px" }}>免責事項</div>
                    </div>
                    各国・地域の要件・規制は事前の周知なく変更されることがあり、
                    本サイトに掲載している情報と異なっている場合があります。
                    実際に輸出される際は、輸出先国・地域の輸入事業者を通じて最新の情報をご確認ください。
                    <br /><br />
                    本サイトの掲載情報の正確性については万全を期しておりますが、
                    農林⽔産省は利⽤者が本サイトの情報を⽤いて⾏う⼀切の⾏為について何ら責任を負うものではありません。
                    <br /><br />
                    本サイトは輸出の一次的検討をする際の参考としてください。輸出にあたっては相手国の一次情報を確認し相手国の輸入業者と相談するようにしてください。
                  </div> */}

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default D007RoadMap;